import { CheckSources } from './check-sources.enum';
import { DatacapAuthResponseDto } from './DTO/FocusPayDatacap/DatacapAuthResponse.dto';
import { I4goPaymentResponseDTO } from './DTO/I4goPaymentRequest.dto';
import { OnlineCustomer } from './DTO/onlineCustomer.model';
import { OOOrderType } from './oo-order-type';
import { OrderPaymentTypes } from './order-payment-types.enum';

export class Order {
	venueKey: number;
	checkKey?: string;
	seats: OrderSeat[] = [];
	orderType: number;
	orderTypeName: string;
	table?: string;
	numberOfGuests: number = 1;
	smsmessage?: string = 'Your order has been placed. See you soon!';
	firstName?: string;
	lastName?: string;
	phone?: string;
	email?: string;
	address?: string;
	address2?: string;
	city?: string;
	state?: string;
	zip?: string;
	deliveryDirections?: string;
	revenueCenter?: string;
	source: CheckSources;
	source2?: string;
	customerKey?: number;
	subtotal?: number;
	taxtotal?: number;
	discountTotal?: number;
	orderTypeChargeTotal?: number;
	gratuityTotal?: number;
	creditCardPassAlongFee?: number;
	total?: number;
	remainingBalance?: number;
	futureOrder?: boolean;
	dueDateTime?: string;
	leadTime: number;
	sendReceipt?: boolean;
	marketingOptIn: boolean;
	linkKey: string;
	onlineCustomer: OnlineCustomer;
	orderTypeRecord: OOOrderType;
	receiptUrl: string;
	paymentMode: string;

	public constructor(init?: Partial<Order>) {
		Object.assign(this, init);
	}
}

export class OrderSeat {
	items: OrderItem[];
	payments?: OrderPayment[];
	subtotal?: number;
	taxtotal?: number;
	discountTotal?: number;
	orderTypeChargeTotal?: number;
	gratuityTotal?: number;
	creditCardPassAlongFee?: number;
	total?: number;
	remainingBalance?: number;
	tabToken?: string;
	tabTipPercent?: number;
	tabAuthorization?: string;

	public constructor(init?: Partial<OrderSeat>) {
		Object.assign(this, init);
	}
}

export class OrderItem {
	menuItemKey: number;
	canvasKey?: number;
	price: number;
	quantity: number;
	priceNumber?: number;
	priceNumberName?: string;
	prepModCommand?: string;
	courseId?: number;
	positionId?: number;
	hold?: boolean;
	name?: string;
	kitchenComment?: boolean;
	modifiers?: OrderItem[];
	uuid?: string;

	preRemove?: boolean;

	public constructor(init?: Partial<OrderItem>) {
		Object.assign(this, init);
	}
}

export class OrderPayment {
	amount: number;
	tip: number;
	tipPercent: number;
	type: OrderPaymentTypes = OrderPaymentTypes.CreditCard;
	// paymentName: string = 'FocusPay';
	// paymentType: string = 'FocusLink';
	token: string;
	securityCode: string;
	status: number;
	paymentKey: string;
	authorization: string;
	firstName: string;
	lastName: string;
	address1: string;
	city: string;
	state: string;
	postalCode: string;
	extendedCardData: string;
	displayName: string; //card display number
	invoiceNumber: string | number;
	checkKey: string;
	focusPay: boolean;
	pspReference: string;
	meta: any;
	venueKey: number;
	displayNumber: string;
	authCode: string;
	sendToProcessor: boolean;
	kioskPaymentRequestKey?: string;

	public constructor(init?: Partial<OrderPayment>) {
		Object.assign(this, init);
	}

	static fromI4goPaymentResponseDto(payment: I4goPaymentResponseDTO, tip?: number): OrderPayment {
		return new OrderPayment({
			amount: payment.amount,
			tip: tip || undefined,
			tipPercent: 0,
			type: OrderPaymentTypes.CreditCard,
			token: payment.token,
			status: 0,
			firstName: payment.firstName,
			lastName: payment.lastName,
			postalCode: payment.postalCode,
			extendedCardData: payment.extendedCardData,
			displayName: payment.displayName || payment.cardNumber,
		});
	}

	static fromDatacapPaymentResponse(payment: DatacapAuthResponseDto, firstName?: string, lastName?: string): OrderPayment {
		return new OrderPayment({
			amount: payment.Tip ? +payment.Amount + +payment.Tip : +payment.Amount,
			tip: +payment.Tip,
			tipPercent: 0,
			type: OrderPaymentTypes.CreditCard,
			token: payment.Token,
			invoiceNumber: payment.InvoiceNo,
			displayName: payment.Account,
			pspReference: payment.RefNo,
			status: 0,
			meta: payment,
			authCode: payment.AuthCode,
		});
	}
}

export class OrderValidateRes {
	checkTotal: number;
	taxTotal: number;
	orderTypeFee: number;
	creditCardPassAlongFee: number;
	outOfStock?: number[];
}
